import './App.css';
import * as React from "react";
import {  Routes, Route } from "react-router-dom";
import Layout from './Pages/Layout'
import Inicio from './Pages/Inicio'
import Conocenos from './Pages/Conocenos'
import QuienSoy from '../src/Pages/quien_soy';
import ComoLoHacemos from '../src/Pages/como_lo_hacemos';
import MisionVision from '../src/Pages/mision_vision';
import Servicios from './Pages/Servicios'
import Default from './Pages/Default'
import { Footer } from './components/Footer';
import { Redes } from '../src/components/Redes_sociales';
import  MiModeloTrabajo from '../src/Pages/MiModeloTrabajo';
import ComoFunciona from './Pages/ComoFunciona';
import EmpiezaAhora from './Pages/EmpiezaAhora';
import AQuienAyudo from './Pages/AQuienAyudo';
import Resultados from './Pages/Resultados';
import Transformacion from './Pages/Transformacion';

function App() {
  return (
    <div className="App">
        <Routes>
          <Route path='/' element={<Layout />}>
            <Route index element={<Inicio />} />
            <Route path='/Conocenos' element={<Conocenos />} />
            <Route path='quien_soy' element={<QuienSoy />} />
            <Route path='como_lo_hacemos' element={<ComoLoHacemos />} />
            <Route path='mision_vision' element={<MisionVision />} />
            <Route path='MiModeloTrabajo' element={<MiModeloTrabajo />}/>
            <Route path='ComoFunciona' element={<ComoFunciona />} />
            <Route path='/Servicios' element={<Servicios />} />
            <Route path='/EmpiezaAhora' element={<EmpiezaAhora />} />
            <Route path='/AQuienAyudo' element={<AQuienAyudo />} />
            <Route path='/Resultados' element={<Resultados/>}/>
            <Route path='/Transformacion' element={<Transformacion/>}/>
            <Route path='*' element={<Default />} />
          </Route>
        </Routes>
      <Redes />
      <Footer />
    </div>
  );
}

export default App;
